import React, { useCallback } from 'react';
import {
  templatesMarketplaceGalleryPagePageView,
  templatesMarketplaceGalleryPageGenericClick,
} from '@wix/bi-logger-partners-data/v2';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { useBi } from './useBi';
import { useTemplateEntry } from './useTemplateEntry';

export const TEMPLATES_BI_CLICK_TYPES = {
  searchBar: 'search bar',
  searchBarMostPopular: 'search bar most popular',
  viewAllTemplates: 'view all templates',
};

type PageViewDetails = {
  message_text?: string;
};

export const useTemplatesBi = ({ is_mobile }: { is_mobile?: boolean }) => {
  const {
    state: { origin, entry: contextEntry },
  } = useTemplatesContext();
  const { entry: urlEntry } = useTemplateEntry();
  const logger = useBi();

  const entry = contextEntry || (urlEntry ?? undefined);

  const logBiPageView = useCallback(
    (details?: PageViewDetails) => {
      logger.report(
        templatesMarketplaceGalleryPagePageView({
          ...(is_mobile && { is_mobile }),
          origin,
          entry,
          ...details,
        }),
      );
    },
    [is_mobile, origin, entry, logger],
  );

  const logBiClick = useCallback(
    ({
      click_type,
      click_data,
      selected_template_id,
      entry: entryOverride,
    }: {
      click_type: string;
      click_data?: any;
      selected_template_id?: string;
      entry?: string;
    }) => {
      logger.report(
        templatesMarketplaceGalleryPageGenericClick({
          origin,
          entry: entryOverride ?? entry,
          click_type: click_type,
          ...(is_mobile && { is_mobile }),
          ...(click_data && { click_data: JSON.stringify({ click_data }) }),
          ...(selected_template_id && { selected_template_id }),
        }),
      );
    },
    [is_mobile, origin, entry, logger],
  );

  return {
    logBiPageView,
    logBiClick,
  };
};
